<template>
  <div class="content">
    <!-- 封面图 -->
    <div
      class="top-banner"
      :style="{
        'background-image': 'url(' + $baseUrl + exam.cover_pc + ')',
      }"
    ></div>
    <!-- 等级考试 -->
    <section class="sec1">
      <div class="sec1-title">
        <h3>
          <span>等<div class="text-under-line"><div class="under-line"></div>级考</div>试</span>
        </h3>
      </div>
      <div class="content1">
        <img :src="$baseUrl + exam1.cover_pc" />
        <div class="content1-text" v-html="exam1.content"></div>
      </div>
    </section>
    <section class="sec2">
      <div class="sec2-main">
        <div class="sec2-main-left">
          <h5><span class="serial">01</span>{{ exam2.title }}</h5>
          <div class="des-text">
            <p class="des-text-1">
              {{ exam2.desc }}
            </p>
            <p>
              <span class="des-text-2">主办单位: </span>{{ exam2.organizer }}
            </p>
            <p>
              <span class="des-text-2">考试时间: </span
              >{{ exam2.ompetition_time }}
            </p>
            <p>
              <span class="des-text-2">申报要求: </span>{{ exam2.requirement }}
            </p>
          </div>
        </div>
        <img :src="$baseUrl + exam2.imgUrl" />
      </div>
    </section>
    <section class="sec3">
      <div class="sec3-main">
        <div class="sec3-main-left">
          <h5><span class="serial">02</span>{{ exam3.title }}</h5>
          <div class="des-text">
            <p class="des-text-1">
              {{ exam3.desc }}
            </p>
          </div>
        </div>
        <img :src="$baseUrl + exam3.imgUrl" />
      </div>
    </section>
    <section class="sec4">
      <div class="tips">
        <div class="title">TIPS:</div>
        <p>
          新高考改革有三个重要变化：转向“以人为本”、专业导向和能力导向。各高等院校也正是为此开设自主招生项目。
          机器人等级考试作为专业领域、专项能力的考核，是针对高考前的中小学在校学生，契合新高考改革方向，注重个性发展与能力培养，助力学生素质教育。
          孩子学习编程，不妨也制定考级计划，不断收获成就感，激发学习动力，提高学习效率。
        </p>
      </div>
    </section>
  </div>
</template>
<script>
import $ from "jquery";
import { getPage, getGames } from "@/api/api.js";
export default {
  data() {
    return {
      exam: {},
      //等级考试
      exam1: {},
      exam2: {},
      exam3: {},
    };
  },
  created() {
    //查询该页面内容
    this.fetchData();
    //查询轮播图
    this.getGames();
  },

  methods: {
    getGames() {
      getGames({ type: 2 }).then((res) => {
        this.exam2 = res.data[0];
        this.exam3 = res.data[1];
      });
    },
    //查询页面模块
    fetchData() {
      getPage({ c_tid: 8 }).then((res) => {
        this.exam = res.data.st_38[0];
        //封面图
        this.exam1 = res.data.st_37[0]; //国际赛事
      });
    },
    chooseItem(n) {
      this.current = n;
    },
  },
  updated() {
    $("p").find("span").css("color", "rgba(153, 153, 153, 1)");
    $(".des-text-2").css({ color: "#313131", "foot-weight": "600" });
  },
};
</script>
<style scoped>
@import "../assets/css/common.css";
.top-banner {
  width: 100%;
  height: 500px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.sec1 {
  margin: 83px 0 36px;
}
.sec1-title {
  text-align: center;
  margin: 0 0 64px;
}
.sec1-title > h3 {
  font-size: 36px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(26, 26, 26, 1);
  margin: 0;
}
.text-under-line {
  display: inline-block;
  position: relative;
}
.under-line {
  position: absolute;
  width: 80%;
  height: 5px;
  border-radius: 5px;
  bottom: -15px;
  left: 0;
  right: 0;
  margin: 0 auto;
  background-color: #ff3500;
}
.content1 {
  margin: 0 auto;
  width: 1200px;
  height: 454px;
  border: 2px solid rgba(251, 155, 0, 0.3);
  box-shadow: 0px 0px 6px 0px rgba(251, 155, 0, 0.75);
  border-radius: 20px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.content1-text {
  width: 400px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(128, 128, 128, 1);
  line-height: 55px;
  text-indent: 36px;
}
.sec2 {
  width: 100%;
  background: rgba(230, 230, 230, 0.3);
}
.sec2-main {
  width: 1200px;
  height: 379px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  word-break: break-all;
}
.sec2-main-left {
  width: 608px;
}
.sec2-main-left > h5 {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(251, 155, 0, 1);
  line-height: 24px;
  margin: 0 0 38px;
}
.serial {
  font-size: 50px;
  font-family: PingFang SC;
  font-weight: 200;
  color: rgba(230, 230, 230, 1);
  line-height: 50px;
  margin-right: 6px;
}
.des-text {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(128, 128, 128, 1);
  line-height: 32px;
  margin: 0;
}
.des-text-1 {
  text-indent: 36px;
}
.des-text-2 {
  font-weight: 800;
  color: #313131;
}
.des-text p {
  margin: 5px 0;
}
.sec3-main {
  width: 1200px;
  height: 379px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  word-break: break-all;
}
.sec3-main-left {
  width: 608px;
}
.sec3-main-left {
  width: 608px;
}
.sec3-main-left > h5 {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #f00055;
  line-height: 24px;
  margin: 0 0 38px;
}

.tips {
  width: 1200px;
  margin: 0 auto 150px;
}
.tips > .title {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(49, 49, 49, 1);
  line-height: 26px;
}
.tips > p {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(128, 128, 128, 1);
  line-height: 26px;
}
</style>